import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { DevicesService, StateService, AppService } from '@services';

/*Models */
import { StatsTrack, Device } from '@models';
@Component({

  selector: 'app-report-stats-item',
  templateUrl: './report-stats-item.component.html',
  styleUrls: ['./report-stats-item.component.scss']
})

export class ReportStatsItemComponent implements OnInit {
  statsTrackList: Array<StatsTrack>;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private currentDevice: Device;

  @Input('statsList') set statsList(statsList) {
    this.statsTrackList = statsList;
  }
  @Input() isMainComponent;

  @Output() updateList: EventEmitter<Array<StatsTrack>> = new EventEmitter<Array<StatsTrack>>();
  @Output() updateListNested: EventEmitter<Array<StatsTrack>> = new EventEmitter<Array<StatsTrack>>();
  constructor(
    private devicesService: DevicesService,
    private stateService: StateService,
    private appService: AppService) { }

  ngOnInit() {
    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
      });
  }


  getDetailStatsEvent(statTrack: StatsTrack) {
    statTrack.loading = true;
    this.devicesService.getStatsTrack(this.currentDevice.id, statTrack.fromUnix, statTrack.toUnix)
      .subscribe(response => {
        statTrack.loading = false;
        this.appService.parseDateReportsStat(response);
        statTrack.active = true;
        statTrack.items = response;
        if (this.isMainComponent) {
          /*Проверяем, если это родительский елемент - посылаем на вывод в график, если нет - сообщаем родителю что обновились данные */
          this.updateList.emit(this.statsTrackList);
        } else {
          this.updateListNested.emit(this.statsTrackList);
        }
      }, errors => {
        statTrack.loading = false;
        console.log(errors);
      });
  }
  updateListNestedEvent() {
    if (this.isMainComponent) {
      /*Проверяем, если это родительский елемент - посылаем на вывод в график, если нет - сообщаем родителю что обновились данные */
      this.updateList.emit(this.statsTrackList);
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/view/components/report-stats-item/report-stats-item.component.ts